import { Component, inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { AppConfig } from '@app/core/app.config';
import { EntityTypeEnum } from '@app/core/enums/entity-type.enum';
import { MeetingInput } from '@app/core/model/entities/meeting/meeting';
import { GeneratesObject } from '@app/shared/interfaces/generates-object';
import { AccessManager } from '@services/managers/access.manager';

@Component({
    selector: 'meeting-create-modal',
    templateUrl: './meeting-create-modal.component.html',
    styleUrl: '../../../../../../../shared/components/form-builder/sections/create-modal.component.scss',
    standalone: false
})
export class MeetingCreateModalComponent implements GeneratesObject {
  protected EntityTypeEnum = EntityTypeEnum;
  protected nameForm: FormControl<string>;
  protected maxLength = inject(AppConfig).FIELD_MAX_LENGTH;

  protected accessManager = inject(AccessManager);

  constructor() {
    this.nameForm = new FormControl(null, Validators.compose([
      Validators.required,
      Validators.maxLength(this.maxLength)
    ]));
  }

  /**
   * Generate the MeetingInput object from the form data
   * @return {MeetingInput}
   */
  public getGeneratedObject(): MeetingInput {
    return {name: this.nameForm.value};
  }
}
